import { BehaviorSubject } from 'rxjs';
import { FlightSchoolFinderFilter } from '../models/flight-school-finder-filter.model';
import * as i0 from "@angular/core";
/**
 * Shares the Flight School Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FlyingClubFinderFiltersService} (a root-provided BehaviorSubject).
 */
var FlightSchoolFinderFiltersService = /** @class */ (function () {
    function FlightSchoolFinderFiltersService() {
        this.flightSchoolFinderFilterSubject$ = new BehaviorSubject(new FlightSchoolFinderFilter());
        this.flightSchoolFinderFilter = this.flightSchoolFinderFilterSubject$.asObservable();
    }
    FlightSchoolFinderFiltersService.prototype.updateFlightSchoolFinderFilters = function (flightSchoolFinderFilter) {
        this.flightSchoolFinderFilterSubject$.next(flightSchoolFinderFilter);
    };
    FlightSchoolFinderFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function FlightSchoolFinderFiltersService_Factory() { return new FlightSchoolFinderFiltersService(); }, token: FlightSchoolFinderFiltersService, providedIn: "root" });
    return FlightSchoolFinderFiltersService;
}());
export { FlightSchoolFinderFiltersService };
